import React from 'react';
import { makeStyles } from '@material-ui/core';
import config from '../../preorder/configs/config';

const useStyle = makeStyles((theme) => ({
  img: {
    display: 'block',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}
));

export default () => {
  const classes = useStyle();
  return (
    <img src={`${config.RESOURCE_URI}PO/230725_Aug_a5_0.jpg`} alt="" className={classes.img} />
  );
};
